import React, { FC, useContext } from "react";
import { SavedOption } from "v3/components/checkout/SavedOption";
import { TenantContext } from "v3/context/tenant";
import { StyledCopy } from "./index.styled";

interface InvoiceOptionProps {
  checked: boolean;
  isDefault?: boolean;
  isDisabled?: boolean;
  onSelect: () => void;
}

export const InvoiceOption: FC<InvoiceOptionProps> = ({
  checked = false,
  isDefault = false,
  isDisabled,
  onSelect,
}) => {
  const { logoSmall } = useContext(TenantContext);

  return (
    <SavedOption
      checked={checked}
      handleClick={onSelect}
      imageAlt="Invoice"
      imageSrc={logoSmall?.src}
      isDefault={isDefault}
      isDisabled={isDisabled}
      showTenantLogo
      title="Pay by Invoice"
    >
      <StyledCopy>Terms according to contract</StyledCopy>
    </SavedOption>
  );
};
